export default {
  "nav": {
    "telecom": "Telecoms",
    "telecomInfrastructures": "Infrastructures",
    "telecomFibre": "Fiber Optics",
    "telecomMaintenance": "Maintenance",
    "genieCivilBTP": "Civil Engineering & Construction",
    "home": "Home",
    "solutions": "Solutions",
    "projets": "Projects",
    "aPropos": "About",
    "contact": "Contact",
    "getQuote": "Request a Quote"
  },
  "footer": {
    "telecomList": {
      "towers": "Towers & Pylons",
      "fibre": "Fibre Optic",
      "maintenance": "NOC Maintenance"
    },
    "tagline": "Leader in telecom infrastructure and energy solutions since 2006. We connect communities and power sustainable development.",
    "subscribe": "Subscribe",
    "subscribePlaceholder": "Your email",
    "services": "Services",
    "servicesList": {
      "microgrids": "Microgrids",
      "solarPumping": "Solar Pumping",
      "storage": "Storage",
      "evCharging": "EV Charging",
      "constructionMetal": "Metal Construction & Civil Engineering",
      "itNetworks": "IT & Networks",
      "audit": "Audit & Consulting",
      "telecom": "Telecommunications",
      "transport": "Transport & Logistics",
      "expertise": "Technical Expertise"
    },
    "company": "Company",
    "companyList": {
      "about": "About",
      "projects": "Our Projects",
      "products": "Products",
      "contact": "Contact"
    },
    "contact": "Contact",
    "copyright": "© 2026 IS TELECOM. All rights reserved.",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "ctaTitle1": "Telecom & energy",
    "ctaTitle2": "infrastructure",
    "ctaTitle3": "for every region",
    "ctaButton": "Request a Quote"
  },
  "hero": {
    "badge": "{ ENERGY & TELECOM }",
    "titleLine1": "Energy &",
    "titleLine2": "telecom",
    "titleLine3": "solutions",
    "subtitle": "Since 2006, IS TELECOM has been deploying telecom infrastructure and energy solutions across 6 countries in Africa.",
    "cta": "Request a Quote"
  },
  "overview": {
    "badge": "About IS TELECOM",
    "titleLine1": "Excellence in",
    "titleLine2": "every infrastructure project",
    "description": "Our multidisciplinary team combines telecom and energy expertise to deliver reliable infrastructure solutions. From transmission towers to solar microgrids, we connect communities and power sustainable development.",
    "learnMore": "Learn More",
    "statYears": "Years of experience",
    "statCountries": "Countries served",
    "statProjects": "Projects completed"
  },
  "features": {
    "badge": "Features",
    "title": "Three areas of expertise, one mission: building Africa's future",
    "items": [
      {"title": "Telecom Infrastructures"},
      {"title": "Civil Engineering & Construction"},
      {"title": "Energy Solutions"}
    ]
  },
  "services": {
    "badge": "Our Services",
    "title": "Solutions tailored to your needs",
    "description": "From solar energy to telecommunications, construction and transport, our multidisciplinary expertise covers all your infrastructure projects.",
    "list": [
      {"title": "Solar Assessment", "tags": ["Solar", "Consulting"]},
      {"title": "Panel Installation", "tags": ["Solar", "Installation"]},
      {"title": "Battery Storage", "tags": ["Solar", "Storage"]},
      {"title": "Monitoring & Support", "tags": ["Solar", "Monitoring"]},
      {"title": "Metal Construction & Civil Engineering", "tags": ["Civil Eng.", "Construction"]},
      {"title": "IT & Networks", "tags": ["IT", "Networks"]},
      {"title": "Audit & Consulting", "tags": ["Audit", "Consulting"]},
      {"title": "Telecommunications", "tags": ["Telecom", "Infrastructure"]},
      {"title": "Transport & Logistics", "tags": ["Logistics", "Transport"]}
    ]
  },
  "projects": {
    "badge": "Our Projects",
    "title": "Our recent projects",
    "viewDetails": "View Details",
    "list": [
      {
        "category": "Microgrids",
        "year": "2023",
        "title": "Village — Rural Electrification",
        "description": "A tailor-made solar system that reduces energy costs and brings clean energy to your community."
      },
      {
        "category": "Telecommunications",
        "year": "2025",
        "title": "Operator — National Telecom Network",
        "description": "Telecom infrastructure deployment with solar power for 200 sites, ensuring reliable connectivity in rural and urban areas."
      },
      {
        "category": "Monitoring",
        "year": "2024",
        "title": "Smart — Advanced Monitoring",
        "description": "Track your system performance with a connected solar installation that helps you understand every kilowatt produced."
      }
    ]
  },
  "partners": {
    "badge": "Our Partners",
    "title": "They trust us",
    "description": "Global leaders in telecommunications, energy and technology collaborate with IS TELECOM to deploy sustainable solutions across Africa."
  },
  "process": {
    "badge": "Process",
    "title": "From study to commissioning",
    "description": "We guide you from initial audit to full commissioning, whether for telecom infrastructure or energy projects.",
    "stepPrefix": "Step",
    "steps": [
      {
        "title": "Study & Engineering",
        "description": "We analyze your needs, study the terrain and design detailed engineering plans for your infrastructure project."
      },
      {
        "title": "Construction & Installation",
        "description": "Our certified teams carry out civil engineering, erect structures and install equipment with precision and safety."
      },
      {
        "title": "Testing & Commissioning",
        "description": "We rigorously test each component, validate performance and ensure full commissioning of your infrastructure."
      }
    ]
  },
  "testimonials": {
    "badge": "Client Testimonials",
    "titleLine1": "Trusted partners,",
    "titleLine2": "reliable infrastructure",
    "verifiedReviews": "verified reviews",
    "items": [
      {
        "quote": "IS TELECOM deployed over 200 sites for our network in Senegal. Their team perfectly masters Huawei equipment and met all deadlines, even in the most difficult-to-access areas.",
        "name": "Ahmadou Diallo",
        "role": "Network Director, MTN Senegal"
      },
      {
        "quote": "The quality of their work on our fiber optic backbone is remarkable. Impeccable OTDR tests, complete documentation, and a team that knows Ericsson standards inside out.",
        "name": "Amina Diallo",
        "role": "Infrastructure Manager, Orange CI"
      },
      {
        "quote": "Their 24/7 NOC support makes all the difference. When a site goes down at 3am, the IS TELECOM team is already on site by 5am. A level of responsiveness you won't find anywhere else.",
        "name": "Koffi Agbessi",
        "role": "Technical Director, Moov Africa"
      },
      {
        "quote": "We entrusted them with the 4G modernization of 150 sites. Team training, installation, radio optimization — everything was delivered on time with quality exceeding our expectations.",
        "name": "Dr Fatou Beye",
        "role": "CTO, Airtel Senegal"
      },
      {
        "quote": "IS TELECOM is our reference partner for masts. Their structures are robust, compliant with seismic standards, and the civil engineering is impeccable. Truly quality work.",
        "name": "Moussa Coulibaly",
        "role": "Deployment Manager, Vodacom"
      },
      {
        "quote": "Fast and clean FTTH deployment. In 3 months, they cabled our entire metropolitan area. Their GPON expertise and project management are impressive.",
        "name": "Sophie Lawson",
        "role": "CEO, Togocom"
      }
    ]
  },
  "faq": {
    "badge": "FAQ",
    "title": "Frequently Asked Questions",
    "homeFaqs": [
      {"q": "01. What telecom services does IS TELECOM offer?", "a": "We deploy complete telecom infrastructure: towers and masts, fiber optic networks, radio equipment maintenance, and connectivity solutions for rural and urban areas. Partners of Huawei, Ericsson and MTN, we cover the entire telecom chain."},
      {"q": "02. Which countries do you operate in?", "a": "IS TELECOM is present in 6 African countries in West and East Africa: Benin, Togo, Mali, Zambia, Tanzania and Senegal. We have offices in each of these countries and deploy telecom and energy projects there."},
      {"q": "03. What types of telecom towers do you install?", "a": "We design and install all types of masts: self-supporting (up to 120m), guyed, urban monopoles, and tubular masts. Each installation complies with international ANSI/TIA-222 standards."},
      {"q": "04. Do you offer telecom maintenance contracts?", "a": "Absolutely. Our maintenance contracts include scheduled preventive interventions, 24/7 NOC support, corrective interventions within 4 hours (guaranteed SLA), and complete spare parts management."}
    ]
  },
  "contact": {
    "pageTitle": "Contact Us",
    "pageSubtitle": "Ready to deploy your telecom infrastructure or energy project? Our team is here to assist you",
    "infoPhone": "Phone",
    "infoEmail": "Email",
    "infoAddress": "Address",
    "infoHours": "Hours",
    "hoursLine1": "Monday - Friday: 8:00 AM - 6:00 PM",
    "hoursLine2": "NOC Support: 24/7",
    "formTitle": "Send Us a Message",
    "formSubtitle": "Fill out the form below and our team will respond within 24 hours.",
    "formSuccess": "Message Sent!",
    "formSuccessMsg": "We will get back to you as soon as possible.",
    "labelName": "Full Name",
    "placeholderName": "Your full name",
    "labelEmail": "Email",
    "placeholderEmail": "your@email.com",
    "labelPhone": "Phone",
    "placeholderPhone": "+229 XX XX XX XX",
    "labelSubject": "Subject",
    "subjectOptions": {
      "info": "General Information",
      "tech": "Technical Information",
      "partnership": "Partnership",
      "careers": "Careers",
      "other": "Other"
    },
    "labelMessage": "Message",
    "placeholderMessage": "Describe your project or questions...",
    "sending": "Sending...",
    "send": "Send Message",
    "quickResponse": "Need a quick answer?",
    "freeQuote": "Free Quote:",
    "freeQuoteDesc": "Receive an estimate within 48 business hours for any infrastructure project.",
    "techSupport": "Technical Support:",
    "techSupportDesc": "Our NOC is available 24/7 for customers with maintenance contracts.",
    "siteVisit": "On-Site Visit:",
    "siteVisitDesc": "We travel free of charge to assess your infrastructure needs.",
    "faqTitle": "Frequently Asked Questions",
    "contactFaqs": [
      {"q": "How long does a telecom site deployment take?", "a": "For a standard site, the timeline is 2 to 4 weeks after the engineering study. For fiber backbone or multi-site projects, the schedule is customized based on the project scope."},
      {"q": "Do you offer telecom maintenance services?", "a": "Yes, all our contracts include scheduled preventive maintenance and 24/7 NOC support with guaranteed 4-hour intervention. We also offer extended maintenance contracts."},
      {"q": "How long to get a quote?", "a": "We send you a detailed quote within 48 business hours after receiving your request. For complex projects, a technical site visit may be necessary."},
      {"q": "Do you work outside Africa?", "a": "Our activity is focused on 6 African countries: Benin, Togo, Mali, Zambia, Tanzania and Senegal. This targeted presence allows us to offer local expertise and optimal responsiveness in each of these markets."},
      {"q": "What certifications do you have?", "a": "We are ISO 9001 and ISO 14001 certified. Our teams are trained and certified by Huawei, Ericsson and Nokia. All our installations comply with ANSI/TIA-222 standards."}
    ]
  },
  "devis": {
    "pageTitle": "Request Your Personalized Quote",
    "pageSubtitle": "Describe your telecom or energy infrastructure project and receive a detailed estimate within 48 hours, with no obligation",
    "badge": "Free Quote",
    "advantages": [
      {"text": "Response within 48h"},
      {"text": "Free & no-obligation quote"},
      {"text": "Personalized study by our experts"},
      {"text": "Operating in 6 countries"}
    ],
    "step1Title": "Step 1: Your Information",
    "step2Title": "Step 2: Your Project",
    "step3Title": "Step 3: Summary",
    "labelName": "Full Name",
    "labelCompany": "Company / Organization",
    "placeholderCompany": "Your company name",
    "labelEmail": "Email",
    "labelPhone": "Phone",
    "labelLocation": "Project Location",
    "placeholderLocation": "City, Country",
    "labelProjectType": "Project Type",
    "selectProject": "Select project type",
    "labelBudget": "Estimated Budget",
    "selectBudget": "Select a range",
    "labelTimeline": "Desired Timeline",
    "selectTimeline": "Select a timeline",
    "labelPower": "Technical Details (optional)",
    "placeholderPower": "E.g.: 80m mast, 200km backbone, 50 telecom sites...",
    "labelDescription": "Project Description",
    "placeholderDescription": "Describe your infrastructure project, goals, technical constraints...",
    "continue": "Continue",
    "back": "Back",
    "send": "Submit Request",
    "sending": "Sending...",
    "success": "Quote Requested Successfully!",
    "successMsg": "Our team is analyzing your project and will respond within 48 business hours with a detailed proposal.",
    "recapName": "Name:",
    "recapCompany": "Company:",
    "recapEmail": "Email:",
    "recapPhone": "Phone:",
    "recapProjectType": "Project Type:",
    "recapLocation": "Location:",
    "recapBudget": "Budget:",
    "recapTimeline": "Timeline:",
    "recapPower": "Technical Details:",
    "recapDescription": "Description:",
    "projectTypes": [
      {"value": "micro-reseau", "label": "Solar Microgrid"},
      {"value": "pompage", "label": "Solar Pumping"},
      {"value": "stockage", "label": "Energy Storage"},
      {"value": "recharge-ve", "label": "EV Charging"},
      {"value": "residentiel", "label": "Residential Installation"},
      {"value": "industriel", "label": "Industrial Installation"},
      {"value": "btp", "label": "Metal Construction & Civil Engineering"},
      {"value": "informatique", "label": "IT (Networks, Servers)"},
      {"value": "audit", "label": "Audit & Consulting"},
      {"value": "telecom", "label": "Telecom (Towers, Fiber)"},
      {"value": "transport", "label": "Transport & Logistics"},
      {"value": "autre", "label": "Other Project"}
    ],
    "budgets": [
      {"value": "", "label": "Select a range"},
      {"value": "moins-5k", "label": "Under €5,000"},
      {"value": "5k-20k", "label": "€5,000 - €20,000"},
      {"value": "20k-100k", "label": "€20,000 - €100,000"},
      {"value": "100k-500k", "label": "€100,000 - €500,000"},
      {"value": "plus-500k", "label": "Over €500,000"}
    ],
    "timelines": [
      {"value": "", "label": "Select a timeline"},
      {"value": "urgent", "label": "Urgent (under 1 month)"},
      {"value": "1-3", "label": "1 to 3 months"},
      {"value": "3-6", "label": "3 to 6 months"},
      {"value": "6-12", "label": "6 to 12 months"},
      {"value": "plus-12", "label": "Over 12 months"}
    ],
    "afterTitle": "What Happens After Your Request",
    "afterBadge": "What's Next?",
    "afterSteps": [
      {"title": "Confirmation", "desc": "You receive a confirmation email with a summary of your request within 1 hour."},
      {"title": "Expert Analysis", "desc": "Our technical team studies your project and assesses technical feasibility."},
      {"title": "Detailed Quote", "desc": "You receive a complete quote with technical specifications, timelines and pricing within 48h."},
      {"title": "Personalized Discussion", "desc": "A project manager contacts you to discuss the quote and answer your questions."}
    ],
    "faqTitle": "Questions About Quotes",
    "devisFaqs": [
      {"q": "Is the quote really free?", "a": "Yes, absolutely. The study of your project and the preparation of the quote are completely free and with no obligation on your part."},
      {"q": "How quickly will I receive my quote?", "a": "We commit to sending you a detailed quote within 48 business hours. For complex projects requiring a site visit, the timeline may be 5 to 7 days."},
      {"q": "What does the quote include?", "a": "The quote includes: detailed technical specifications, complete equipment list, installation schedule, warranty terms, and the detailed total price."},
      {"q": "Can I modify my project after receiving the quote?", "a": "Of course! The quote is a basis for discussion. Our teams are available to adjust the solution to your needs and constraints."}
    ]
  },
  "about": {
    "pageTitle": "About IS TELECOM",
    "pageSubtitle": "The story of a telecommunications pioneer in Africa, serving connectivity since 2006",
    "missionBadge": "Our Mission",
    "missionTitle": "Connecting Africa to tomorrow's networks",
    "missionDesc1": "IS TELECOM was founded in 2006 with an ambitious vision: building the telecommunications infrastructure that connects African populations to the rest of the world. From Cotonou, we have woven a network of trust with the world's largest telecom players.",
    "missionDesc2": "Today, partners of Huawei, Ericsson, MTN, Orange and many others, we have deployed over 5,000 telecom sites across 6 African countries. Our expertise covers the entire chain: towers, fiber optics, maintenance and solar power for isolated sites.",
    "statCountries": "Countries Served",
    "statProjects": "Projects Completed",
    "statExperts": "Experts Deployed",
    "statCapacity": "Telecom Sites Deployed",
    "certifiedBadge": "ISO 9001 Certified",
    "certifiedSub": "Quality Guaranteed",
    "valuesBadge": "Our Values",
    "valuesTitle": "What guides us every day",
    "values": [
      {"title": "Universal Connectivity", "desc": "We believe every community deserves reliable access to telecommunications networks, from metropolises to the most isolated villages."},
      {"title": "Technical Excellence", "desc": "All our sites comply with the strictest international standards. Our teams are trained and certified by Huawei, Ericsson and Nokia."},
      {"title": "International Reach", "desc": "Present in 6 countries in West and East Africa, we adapt our connectivity solutions to local contexts and specific needs."},
      {"title": "Continuous Innovation", "desc": "We invest in tomorrow's technologies: 5G, IoT, edge computing and smart cities."},
      {"title": "Client Proximity", "desc": "Personalized support with 24/7 NOC technical support, everywhere in Africa."},
      {"title": "Social Impact", "desc": "Every telecom site we deploy creates local jobs and opens access to education, healthcare and the digital economy."}
    ],
    "timelineBadge": "Our Journey",
    "timelineTitle": "19 years of telecom leadership",
    "timeline": [
      {"year": "2006", "title": "Creation of IS TELECOM", "desc": "Company founded in Cotonou, Benin, with a clear mission: deploying the telecom infrastructure that will connect West Africa."},
      {"year": "2009", "title": "Huawei Partnership", "desc": "Signing of the first partnership contract with Huawei Technologies for radio infrastructure deployment in West Africa. Training of our first certified teams."},
      {"year": "2012", "title": "Ericsson Partnership", "desc": "IS TELECOM becomes an Ericsson certified partner for RAN (Radio Access Network) equipment maintenance and deployment. Expansion into Togo and Mali."},
      {"year": "2015", "title": "MTN Framework Contract", "desc": "Signing of a multi-year framework contract with MTN for the deployment and maintenance of over 800 telecom sites across our 6 countries of operation."},
      {"year": "2019", "title": "4G & Fiber Deployment", "desc": "Launch of the first 4G/LTE deployments and fiber optic backbone networks. Over 2,000 telecom sites under active management."},
      {"year": "2024", "title": "Pan-African Leader", "desc": "Over 5,000 telecom sites deployed in 6 African countries. Strategic partnerships with Orange, Airtel, Vodacom. ISO 9001 certification and 5G prequalification."}
    ],
    "certBadge": "Certifications",
    "certTitle": "Our Certifications",
    "certDesc": "International standards to guarantee the quality and safety of our telecom infrastructure",
    "certs": [
      {"label": "ISO 9001", "desc": "Quality"},
      {"label": "Huawei Certified", "desc": "Approved Partner"},
      {"label": "Ericsson Certified", "desc": "RAN & Core"},
      {"label": "ISO 14001", "desc": "Environment"}
    ]
  },
  "solutions": {
    "pageTitle": "Our Solutions & Services",
    "pageSubtitle": "Telecom infrastructure and custom energy systems to meet all your needs, from transmission towers to industrial solar projects",
    "processBadge": "Our Process",
    "processTitle": "How We Work",
    "processSteps": [
      {"title": "Audit & Consulting", "desc": "Analysis of your technical needs and on-site feasibility study, whether for telecom or energy."},
      {"title": "Design", "desc": "Custom sizing with detailed engineering plans for your infrastructure."},
      {"title": "Installation", "desc": "Implementation by our certified teams, in compliance with international standards."},
      {"title": "Monitoring & Maintenance", "desc": "Remote monitoring and guaranteed preventive interventions 24/7."}
    ],
    "ctaTitle": "Need a custom solution?",
    "ctaSubtitle": "Our engineers study your telecom or energy project for free and propose a solution tailored to your needs and budget.",
    "ctaButton": "Request a Free Audit",
    "keyFeatures": "Key Features",
    "useCases": "Use Cases",
    "requestQuote": "Request a Quote for This Solution",
    "solutions": [
      {
        "title": "Microgrid Systems",
        "shortDesc": "Complete solutions for rural and urban electrification with smart management.",
        "fullDesc": "Our microgrid systems are designed to provide reliable and sustainable power in areas not connected to the national grid. Each solution integrates photovoltaic panels, storage batteries, smart inverters and a centralized monitoring system.",
        "features": ["Automated production and consumption management", "Real-time monitoring via web and mobile platform", "Predictive maintenance with automatic alerts", "Easy integration with existing energy sources", "Smart pricing and subscriber management"],
        "useCases": ["Rural villages in Africa", "Peri-urban areas", "Isolated islands", "Remote industrial sites"]
      },
      {
        "title": "Solar Pumping",
        "shortDesc": "Solar pumping and irrigation systems for agriculture and water supply.",
        "fullDesc": "Our solar pumping solutions transform sunlight into drinking water and irrigation. Adapted to rural and agricultural contexts, they reduce operational costs and ensure constant water availability.",
        "features": ["High-efficiency submersible pumps", "Integrated drip irrigation systems", "Automatic flow and pressure control", "Compatible with deep boreholes and wells", "Robustness adapted to extreme weather conditions"],
        "useCases": ["Agricultural operations", "Rural communities", "Livestock farms", "Botanical gardens"]
      },
      {
        "title": "Energy Storage",
        "shortDesc": "Residential and industrial storage solutions with high-performance lithium batteries.",
        "fullDesc": "Storage is the heart of any autonomous solar installation. We offer next-generation lithium-ion battery solutions, with capacities ranging from residential to industrial, combined with intelligent hybrid inverters.",
        "features": ["High energy density lithium batteries", "Hybrid inverters with automatic switching", "Intelligent charge/discharge cycle management", "Modular scalability as needed", "Extended warranty up to 15 years"],
        "useCases": ["Individual homes", "Hotels and resorts", "Health centers", "Industries"]
      },
      {
        "title": "EV Charging",
        "shortDesc": "Solar-powered electric vehicle charging stations, complete and sustainable solutions.",
        "fullDesc": "We install electric vehicle charging stations powered 100% by solar energy. From residential chargers to public fast-charging stations, we design solutions adapted to every need.",
        "features": ["Fast charging stations (up to 150 kW)", "Solar power with buffer storage", "Flow management and tariff optimization", "Consumption and session monitoring", "Compatibility with all charging standards"],
        "useCases": ["Corporate parking lots", "Service stations", "Shopping centers", "Collective residences"]
      },
      {
        "title": "Residential Solutions",
        "shortDesc": "Solar systems for homes, hotels and healthcare facilities.",
        "fullDesc": "Our residential solutions combine performance, aesthetics and simplicity. Each installation is custom-made, sized according to household consumption and site constraints. Turnkey installation with maintenance included.",
        "features": ["Turnkey installation in 2 to 5 days", "Preventive and corrective maintenance included", "Extended warranty on equipment and labor", "Remote production monitoring", "Self-consumption and surplus sale"],
        "useCases": ["Individual homes", "Hotels and guesthouses", "Clinics and pharmacies", "Schools and training centers"]
      },
      {
        "title": "Industrial Solutions",
        "shortDesc": "High-power systems for rural areas, mining operations and industries.",
        "fullDesc": "For the most demanding energy needs, we deploy high-power industrial systems. From isolated mines to industrial zones, our solutions guarantee reliable 24/7 power with optimized return on investment.",
        "features": ["Capacities from 100 kW to multiple MW", "Certified industrial robustness", "24/7 technical support with dedicated hotline", "Hybrid diesel/solar integration possible", "Centralized multi-site supervision"],
        "useCases": ["Mines and quarries", "Industrial zones", "Manufacturing plants", "Ports and airports"]
      },
      {
        "title": "Telecom Towers & Masts",
        "shortDesc": "Installation and maintenance of telecommunication towers, self-supporting and guyed masts.",
        "fullDesc": "IS TELECOM is a major player in telecom infrastructure deployment in Africa. We design, manufacture and install telecommunication towers of all dimensions: self-supporting towers, guyed masts, monopoles and tubular masts. Our teams operate on all types of terrain, from dense urban centers to the most isolated rural areas.",
        "features": ["Self-supporting towers up to 120 meters", "Guyed towers for high-wind areas", "Compact urban monopoles", "Foundations and civil engineering included", "International standards (ANSI/TIA-222)"],
        "useCases": ["Mobile operators (MTN, Orange, Vodacom)", "Microwave links", "Broadcasting & TV", "Energy (wind, monitoring)"]
      },
      {
        "title": "Fiber Optic Networks",
        "shortDesc": "Deployment of fiber optic networks and transmission backbones for telecom operators.",
        "fullDesc": "We deploy fiber optic networks end-to-end: engineering studies, cable pulling, splicing, performance testing and commissioning. Our teams master GPON, FTTH technologies and long-distance backbones. Reference partners of major African operators.",
        "features": ["FTTH (Fiber To The Home) deployment", "Long-distance intercity backbones", "Fusion splicing and OTDR testing", "Engineering studies and detailed preliminary designs", "Maintenance and repair of damaged cables"],
        "useCases": ["Metropolitan networks", "Connecting isolated sites", "Data centers and telecom hubs", "University campuses and industrial zones"]
      },
      {
        "title": "Telecom Maintenance & Services",
        "shortDesc": "Preventive, corrective maintenance and 24/7 technical support for your telecom infrastructure.",
        "fullDesc": "Your network reliability depends on rigorous maintenance. IS TELECOM offers customized maintenance contracts for your telecom infrastructure: scheduled preventive interventions, rapid corrective troubleshooting, 24/7 technical support and spare parts management. Our teams are trained and certified by the largest equipment manufacturers.",
        "features": ["Preventive maintenance with customized planning", "Corrective intervention within 4h (guaranteed SLA)", "24/7 NOC technical support", "Spare parts and buffer stock management", "Monthly performance reports (KPIs)"],
        "useCases": ["Operational telecom sites", "Data centers", "Radio base stations", "Switching centers"]
      }
    ]
  },
  "notFound": {
    "title": "Page Not Found",
    "description": "The page you are looking for does not exist or has been moved.",
    "backHome": "Back to Home"
  },
  "langSelector": {
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "zh": "中文",
    "ar": "العربية"
  }
};